import React from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import { Row, Col } from 'react-flexbox-grid'
import CatalogoItem from './catalogoItem'

class CatalogoListado extends React.Component {
    

    render() {
        return (
            <div className='catalogo'>

                {/* menú superior */}
                <TitleBar 
                    title={'Catálogo'} 
                    type='list' 
                    searchPlaceholder='Ingrese catálogo'
                    handleOnSearch={this.props.handleOnSearch} 
                    showSearch = {true}
                    newButtonLink = '/Catalogo/catalogoNuevo'
                />
                
                <Row className = {this.props.catalogos.length !== 0 ? "catalogoContainer" : null} >
                    { this.props.catalogos.map((c,i) => {  
                                    
                    return (  
                        <Col md={true} className='catalogoItem'>
                            {c.fechaPublicacion !== null ? <div className='picker publicado'> </div> : ''}
                            <CatalogoItem catalogo={c} />
                        </Col> 
                    )}) 
                    }
                </Row>
            </div>
        )
    }
}

CatalogoListado.propTypes = {
    catalogos: PropTypes.object.isRequired,
    handleOnChange: PropTypes.func.isRequired,
    handleOnDropFile: PropTypes.func.isRequired,
    handleOnSave: PropTypes.func.isRequired,   
    handleOnSearch : PropTypes.func.isRequired
}

CatalogoListado.defaultProps = {
    catalogos: []
}

export default CatalogoListado